import { render, staticRenderFns } from "./PromotionsDataTable.vue?vue&type=template&id=29c7a006"
import script from "./PromotionsDataTable.vue?vue&type=script&lang=ts"
export * from "./PromotionsDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports